import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    padding: 20px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    padding: 16px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    padding: 12px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 20px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    margin-bottom: 16px;
  }
`;

export const Title = styled.h1`
  color: ${props => props.theme.text};
  margin: 0;
  font-size: 28px;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    font-size: 24px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    font-size: 22px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const AddButton = styled.button`
  width: 205px;
  height: 45px;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  border-radius: 10px;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  flex-shrink: 0;

  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    width: 180px;
    height: 42px;
    font-size: 13px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    width: 100%;
    height: 48px;
    font-size: 16px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    height: 44px;
  }
`;

export const UserList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const UserItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.usersDivBackground};
  padding: 16px;
  border-radius: 10px;
  color: ${props => props.theme.text};
  font-size: 16px;
  font-weight: 500;
  min-height: 60px;
  gap: 16px;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    padding: 14px;
    font-size: 15px;
    gap: 12px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
    gap: 12px;
    min-height: auto;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    padding: 12px;
    font-size: 14px;
    gap: 8px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-end;
    gap: 12px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    justify-content: center;
    gap: 16px;
  }
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.primaryOn};
  transition: all 0.2s;
  border-radius: 6px;
  min-width: 36px;
  min-height: 36px;

  .icon {
    width: 20px;
    height: 20px;
  }

  &:hover {
    opacity: 0.8;
    background-color: rgba(255, 255, 255, 0.1);
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    padding: 10px;
    min-width: 40px;
    min-height: 40px;
    
    .icon {
      width: 22px;
      height: 22px;
    }
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    padding: 12px;
    min-width: 44px;
    min-height: 44px;
    
    .icon {
      width: 24px;
      height: 24px;
    }
  }
`;

export const EditButton = styled(IconButton)`
  color: ${({ theme }) => theme.primaryAccent};
`;

export const DeleteButton = styled(IconButton)`
  color: ${({ theme }) => theme.error};
`;

export const DeleteModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const DeleteModalContent = styled.div`
  background-color: ${({theme}) => theme.deleteModalBackground};
  border-radius: 8px;
  border: 1px solid ${({theme}) => theme.deleteModalBorder};
  padding: 24px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  
  h3 {
    color: ${({theme}) => theme.error};
    margin-bottom: 16px;
    font-size: 18px;
  }
  
  p {
    margin-bottom: 24px;
    line-height: 1.5;
    color: ${({theme}) => theme.text};
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    width: 95%;
    padding: 20px;
    border-radius: 12px;
    
    h3 {
      font-size: 16px;
      margin-bottom: 12px;
    }
    
    p {
      margin-bottom: 20px;
      font-size: 14px;
    }
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    padding: 16px;
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const DeleteModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 8px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    margin-top: auto;
    padding-top: 20px;
  }
`;

export const CancelButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid ${({theme}) => theme.border};
  background-color: ${({theme}) => theme.backgroundCancelButtonDeleteModal};
  color: ${({theme}) => theme.text};
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  min-height: 36px;
  
  &:hover {
    background-color: ${({theme}) => theme.hoverCancelButtonDeleteModal};
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 16px;
    min-height: 44px;
    width: 100%;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    min-height: 48px;
  }
`;

export const ConfirmButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  background-color: ${({theme}) => theme.backgroundConfirmButtonDeleteModal};
  color: ${({ theme }) => theme.errorOn};
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  min-height: 36px;
  
  &:hover {
    background-color: ${({theme}) => theme.hoverConfirmButtonDeleteModal};
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 16px;
    min-height: 44px;
    width: 100%;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    min-height: 48px;
  }
`;

// Novos componentes responsivos para substituir o grid fixo
export const UserInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 1fr;
  gap: 16px;
  flex: 1;
  min-width: 0;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1.5fr 1fr;
    gap: 12px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }
`;

export const UserInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
`;

export const UserInfoLabel = styled.span`
  font-size: 12px;
  color: ${props => props.theme.textSecondary || props.theme.placeholderColor};
  font-weight: 400;
  margin-bottom: 2px;
  display: none;

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    display: block;
    min-width: 80px;
    font-weight: 500;
  }
`;

export const UserInfoValue = styled.span`
  font-weight: 500;
  color: ${props => props.theme.text};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    white-space: normal;
    word-break: break-word;
  }
`; 